export enum CategoryType {
    Equipment = 1,
    Occupancies = 2,
    Spaces = 3,
    Systems = 4,
}
